import React, { useState } from "react";
import BarcodeScanner from "react-qr-barcode-scanner";

export default function QRBarcodeScanner({ onDetected, onClose }) {
  const [stopStream, setStopStream] = useState(false);

  const handleDetect = (err, result) => {
    if (result?.text) {
      console.log("Detected:", result.text, "Format:", result.format);

      setStopStream(true);
      onDetected(result.text); // works for QR + barcode
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Close button */}
      <button
        className="dialog-scanner-close"
        onClick={() => {
          setStopStream(true);
          onClose?.();
        }}
        style={{
          position: "absolute",
          zIndex: 10,
          right: 10,
          top: 10
        }}
      >
        ✕
      </button>

      <BarcodeScanner
        width={500}
        height={500}
        delay={300}
        stopStream={stopStream}
        facingMode="environment"
        onUpdate={handleDetect}
      />
    </div>
  );
}